import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Set } from 'immutable';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

import Territory from '../../classes/geo/territory';
import { Checkbox } from '../Controls';
import FixedBody from '../Common/FixedBody';
import { DISTRICTS } from '../../consts';

class TerritorialDivisionModal extends Component {
  constructor (props) {
    super(props);

    this.territory = new Territory(props.domain);

    this.getInitialState = this.getInitialState.bind(this);

    this.handlerClose = this.handlerClose.bind(this);
    this.handlerSaveFilter = this.handlerSaveFilter.bind(this);
    this.handlerClearFilter = this.handlerClearFilter.bind(this);

    this.state = this.getInitialState(props.filter);
  }

  getInitialState (filter) {
    const state = {};
    const districtValue = filter.get('district');
    const regionDistrictValue = filter.get('regionDistrict');
    const microDistrictValue = filter.get('microdistrict');
    const subwayValue = filter.get('subwayId');

    // метро
    state.subwayId = new Set(subwayValue ? subwayValue.split(',').map(i => parseInt(i)) : []);

    // районы
    state.district = new Set(districtValue ? districtValue.split(',').map(i => (i === DISTRICTS.center || i === DISTRICTS.suburb) ? i : parseInt(i)) : []);

    // микрорайоны
    const microdistrictList = microDistrictValue ? microDistrictValue.split(',').map(i => parseInt(i)) : [];
    state.district.map(id => {
      this.territory.getMicroDistricts(id).map(item => microdistrictList.push(item.id));
    });
    state.microdistrict = new Set(microdistrictList);

    // область (используется для совместимости метода this.getHandlerChecked,
    // реально для хранения используется state.district)
    state.suburb = new Set(state.district.has(DISTRICTS.suburb) ? [DISTRICTS.suburb] : []);

    // районы области
    const regionDistrictList = regionDistrictValue ? regionDistrictValue.split(',').map(i => parseInt(i)) : [];
    if (state.district.has(DISTRICTS.suburb)) {
      this.territory.getRegionDistricts().map(item => regionDistrictList.push(item.id));
    }
    state.regionDistrict = new Set(regionDistrictList);

    return state;
  }

  componentWillReceiveProps (nextProps, nextContext) {
    if (!this.props.filter.equals(nextProps.filter)) {
      this.setState(this.getInitialState(nextProps.filter));
    }
  }

  handlerClose (e) {
    e.preventDefault();
    e.stopPropagation();
    this.props.onClose();

    this.setState(this.getInitialState(this.props.filter));
  }

  getHandlerChecked (field) {
    const that = this;
    return function (id, checked) {
      // если клик по району, то переключаем микрорайоны
      if (field === 'district') {
        let microdistrict = that.state.microdistrict;
        that.territory.getMicroDistricts(id).map(item => {
          microdistrict = microdistrict[checked ? 'add' : 'delete'](item.id);
        });

        that.setState({
          microdistrict
        });
      }

      // клик по всей области
      if (field === 'suburb') {
        let regionDistrict = new Set(checked ? that.territory.getRegionDistricts().map(item => item.id) : []);

        that.setState({
          regionDistrict,
          district: that.state.district[checked ? 'add' : 'delete'](DISTRICTS.suburb)
        });
      }

      // если клик по микрорайону, то переключаем район
      if (field === 'microdistrict') {
        const district = that.territory.getLocalityDistrictByMicroDistrictId(id, true);
        if (checked && district) {
          const countMicroDistricts = that.state.microdistrict.add(id)
            .intersect(district.microDistricts.map(item => item.id))
            .size;

          that.setState({
            district: countMicroDistricts === district.microDistricts.length
              ? that.state.district.add(district.id)
              : that.state.district.delete(district.id)
          });
        } else if (district) {
          that.setState({
            district: that.state.district.delete(district.id)
          });
        }
      }

      // если клик по району области, то переключаем область
      if (field === 'regionDistrict') {
        let suburbOperation = 'delete';

        if (checked) {
          const regionDistricts = that.territory.getRegionDistricts();
          const countRegionDistricts = that.state.regionDistrict.add(id)
              .intersect(regionDistricts.map(item => item.id))
              .size;

          suburbOperation = countRegionDistricts === regionDistricts.length ? 'add' : 'delete';
        }

        that.setState({
          suburb: that.state.suburb[suburbOperation](DISTRICTS.suburb),
          district: that.state.district[suburbOperation](DISTRICTS.suburb)
        });
      }

      // по чему кликнули, то и меняем
      that.setState({
        [field]: checked ? that.state[field].add(id) : that.state[field].delete(id)
      });
    };
  }

  handlerClearFilter (e) {
    e.preventDefault();
    e.stopPropagation();

    this.setState({
      regionDistrict: new Set(),
      district: new Set(),
      subwayId: new Set(),
      microdistrict: new Set(),
      suburb: new Set()
    });
  }

  handlerSaveFilter (e) {
    e.preventDefault();
    e.stopPropagation();
    this.props.onClose();

    const subwayId = this.state.subwayId.size ? this.state.subwayId.join(',') : null;
    const district = this.state.district.size ? this.state.district.join(',') : null;
    let microdistrict = this.state.microdistrict.slice();
    this.state.district.map(id => {
      this.territory.getMicroDistricts(id).map(item => {
        microdistrict = microdistrict.remove(item.id);
      });
    });

    const regionDistrict = this.state.district.has(DISTRICTS.suburb)
      ? null
      : (this.state.regionDistrict.size ? this.state.regionDistrict.join(',') : null);

    this.props.onUpdateFilter({
      regionDistrict,
      district,
      subwayId,
      microdistrict: microdistrict.size ? microdistrict.join(',') : null,
      page: 1
    });
  }

  getFilter (field, id) {
    return this.state[field].get(id, false) || false;
  }

  renderTableOfContent () {
    const localityDistricts = this.territory.getLocalityDistricts();
    const countLD = this.territory.getCountLocalityDistricts();
    const countRD = this.territory.getCountRegionDistricts();

    return [
      (countLD > 0 && <h2 key='toc-head-districts' className='territorial-title header'>Районы</h2>),
      countLD > 0 && localityDistricts.map(district => {
        return (
          <div className='group__item' key={`toc-check-${district.id}`}>
            <Checkbox
              id={district.id}
              label={district.name}
              checked={this.getFilter('district', district.id)}
              onUpdate={this.getHandlerChecked('district')}
            />
          </div>
        );
      }),
      (countRD > 0 && <h2 key={`toc-head-${DISTRICTS.suburb}`} className='territorial-title header'>Область</h2>),
      (countRD > 0 && <div key={`toc-check-${DISTRICTS.suburb}`} className='checkbox__item'>
        <Checkbox
          id={DISTRICTS.suburb}
          label='Вся область'
          checked={this.getFilter('suburb', DISTRICTS.suburb)}
          onUpdate={this.getHandlerChecked('suburb')}
        />
      </div>)
    ];
  }

  renderMicroDistricts () {
    const localityDistricts = this.territory.getLocalityDistricts();

    return localityDistricts.map(district => {
      const microDistricts = this.territory.getMicroDistricts(district.id);
      const countMD = microDistricts.length;

      return (
        <div key={district.id} className='territorial-row-wrapper'>
          <div className='group__header'>
            <Checkbox
              id={district.id}
              label={district.name}
              checked={this.getFilter('district', district.id)}
              onUpdate={this.getHandlerChecked('district')}
            />
          </div>

          { this.renderThreeColumns(microDistricts, countMD, 'microdistrict') }
        </div>
      );
    });
  }

  renderThreeColumns (list, count, field) {
    const limit = count > 3 ? Math.round(count / 3) : 1;
    const data = [
      list.slice(0, limit),
      list.slice(limit, limit * 2),
      list.slice(limit * 2)
    ];

    return this.getRow(data, field);
  }

  getRow (columns, field) {
    return (
      <div className='territorial-row flex'>
        {
          columns.map((col, index) => {
            return this.getColumn(col, index, field);
          })
        }
      </div>
    );
  }

  getColumn (col, index, field) {
    return col.length > 0 && (
      <div className='territorial-col' key={index}>
        {
          col.map((item, idx) => {
            return (
              <div className='checkbox__item' key={idx}>
                <Checkbox
                  id={item.id}
                  label={item.name}
                  checked={this.getFilter(field, item.id)}
                  onUpdate={this.getHandlerChecked(field)}
                />
              </div>
            );
          })
        }
      </div>
    );
  }

  renderForm () {
    const localityDistricts = this.territory.getLocalityDistricts();
    const countLD = this.territory.getCountLocalityDistricts();

    const regionDistricts = this.territory.getRegionDistricts();
    const countRD = this.territory.getCountRegionDistricts();
    const countMD = this.territory.getCountMicroDistrict();

    const subways = this.territory.getSubways();
    const countSW = this.territory.getCountSubways();

    return (
      <div className='territorial-content'>
        <FixedBody />
        {
          (countLD > 0 || countMD > 0) && (
            <div className='territorial-header'>
              <h2 className='territorial-title header'>
                {
                  (countLD && countMD) ? 'Микрорайоны' : 'Районы'
                }
              </h2>
            </div>
          )
        }
        {
          (countLD && countMD)
          ? this.renderMicroDistricts()
          : (
            countLD > 0 && <div className='territorial-row-wrapper'>
              {this.renderThreeColumns(localityDistricts, countLD, 'district')}
            </div>
          )
        }

        {
          countSW > 0 && (
            <div className='territorial-header'>
              <h2 className='territorial-title header'>
                Метро
              </h2>
            </div>
          )
        }
        {
          countSW > 0 && (
            <div className='territorial-row-wrapper'>
              { this.renderThreeColumns(subways, countSW, 'subwayId') }
            </div>
          )
        }

        {
          countRD > 0 && (
            <div className='territorial-header'>
              <h2 className='territorial-title header'>
                Районы области
              </h2>
            </div>
          )
        }
        {
          countRD > 0 && (
            <div className='territorial-row-wrapper'>
              <div className='group__header'>
                <Checkbox
                  id={DISTRICTS.suburb}
                  label='Вся область'
                  checked={this.getFilter('suburb', DISTRICTS.suburb)}
                  onUpdate={this.getHandlerChecked('suburb')}
                />
              </div>

              { this.renderThreeColumns(regionDistricts, countRD, 'regionDistrict') }
            </div>
          )
        }
      </div>
    );
  }

  render () {
    const {visible} = this.props;

    return (
      <div className={'modal territorial-division territorial-division-modal full-screen' + (visible ? ' open fade in' : '')}>
        {
          visible && (
            <div className='modal-dialog full-screen'>
              <div className='modal-content animate-top'>
                <div className='modal-box'>
                  <button type='button' className='close' onClick={this.handlerClose}>×</button>
                  <div className='form-container'>
                    <div className='flex form-container-wrapper'>
                      <div className='form-content-container'>
                        { this.renderTableOfContent() }
                      </div>

                      { this.renderForm() }

                      <div className='controls'>
                        <button
                          type='button'
                          onClick={this.handlerSaveFilter}
                          className='btn btn-primary'
                        >
                          Выбрать
                        </button>

                        <button
                          type='button'
                          onClick={this.handlerClearFilter}
                          className='btn-base btn-secondary'
                        >
                          Очистить
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        }
        <TransitionGroup>
          {
            visible &&
            <CSSTransition key={'modal-backdrop'} appear classNames='fade' timeout={300}>
              <div className='modal-backdrop full-screen' />
            </CSSTransition>
          }
        </TransitionGroup>
      </div>
    );
  }
}

TerritorialDivisionModal.propTypes = {
  domain: PropTypes.object.isRequired,
  filter: PropTypes.object.isRequired,
  visible: PropTypes.bool.isRequired,

  onUpdateFilter: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
};

TerritorialDivisionModal.defaultProps = {};

export default TerritorialDivisionModal;



// WEBPACK FOOTER //
// ./src/ui/TerritorialDivision/TerritorialDivisionModal.jsx